jQuery(document).ready(function ($) {
  if ($('.quote-slider').length) {
    $('.quote-slider').each(function(index, element) {
      var $slider = $(element);
      var sliderId = $slider.attr('id');
      
      // Dynamisch eindeutige IDs für die Pfeile erstellen
      var prevArrowId = 'arrow-prev-' + sliderId.split('-')[2];
      var nextArrowId = 'arrow-next-' + sliderId.split('-')[2];

      // Initialisieren Sie den Slider mit den eindeutigen Pfeilen
      $slider.slick({
        infinite: true,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: $('#' + prevArrowId),
        nextArrow: $('#' + nextArrowId),
      });
    });
  }
});
